
import React, { Component } from 'react';
import MultiSelect from 'react-select';
import { translate } from 'react-i18next';
import '../../../../../App.css';
import './ScheduleList.css';
import ReactTable from 'react-table';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faTimes, faTrashAlt, faCalendarAlt, faEye } from '@fortawesome/fontawesome-free-solid';


import { Row, Col, FormGroup, Input, Label, Modal, ModalBody, Breadcrumb, BreadcrumbItem } from 'reactstrap';

//  ----------------   Form components
import Form from 'react-validation/build/form';
import Select, { select } from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import Textarea from 'react-validation/build/textarea';
import { required, email, alphaNum, lt, minChar8 } from '../../../../formValidation';
import $ from 'jquery';
import ConfirmDialog from '../../../../ConfirmDialog/ConfirmDialog';
class ScheduleList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            scheduleList: [],
            scheduleEditModal: false,
            scheduleOptions: ['uma vez apenas', 'Diariamente', 'Semanalmente', 'Mensalmente'],
            selectedScheduleType: 'uma vez apenas',
            startTimeOpen: false,
            endTimeOpen: false,
            startTime: '',
            endTime: '',
            title: '',
            description: '',
            scheduleId: null,
            weekly: [
                { value: 'sunday', label: 'Domingo' },
                { value: 'monday', label: 'Segunda-feira' },
                { value: 'tuesday', label: 'terca-feira'},
                { value: 'wednesday', label: 'Quarta-feira' },
                { value: 'thursday', label: 'Quinta-feira' },
                { value: 'friday', label: 'Sexta-feira' },
                { value: 'saturday', label: 'Sábado' }
            ],
            dates: [
                { value: '1', label: '1' },
                { value: '2', label: '2' },
                { value: '3', label: '3' },
                { value: '4', label: '4' },
                { value: '5', label: '5' },
                { value: '6', label: '6' },
                { value: '7', label: '7' },
                { value: '8', label: '8' },
                { value: '9', label: '9' },
                { value: '10', label: '10' },
                { value: '11', label: '11' },
                { value: '12', label: '12' },
                { value: '13', label: '13' },
                { value: '14', label: '14' },
                { value: '15', label: '15' },
                { value: '16', label: '16' },
                { value: '17', label: '17' },
                { value: '18', label: '18' },
                { value: '19', label: '19' },
                { value: '20', label: '20' },
                { value: '21', label: '21' },
                { value: '22', label: '22' },
                { value: '23', label: '23' },
                { value: '24', label: '24' },
                { value: '25', label: '25' },
                { value: '26', label: '26' },
                { value: '27', label: '27' },
                { value: '28', label: '28' },
                { value: '29', label: '29' },
                { value: '30', label: '30' },
                { value: '31', label: '31' }
            ],
            selectedDays: [],
            selectedDates: [],
            scheduleItem: {},
        };
    }

    componentDidMount() {
        const { match } = this.props;
        this.props.saveMatchForSidebarMenu(match);
        this.fetchStreamList();
    }

    fetchStreamList = () => {
        $.ajax({
            url: '/api/v1/schedule',
            method: 'GET',
            success: function (result) {
                console.log("rs---->",result)
                this.setState({
                    scheduleList: result.response
                })
            }.bind(this),
            error: function (error) {
                console.log("------",error);
            }.bind(this)
        })
    }

    deletSchedule = () => {
        let data = { id: this.state.scheduleId };
        $.ajax({
            url: '/api/v1/schedule',
            method: 'DELETE',
            data: JSON.stringify(data),
            success: function (resp) {
                this.setState({
                    confirmModal: !this.state.confirmModal
                })
                this.fetchStreamList();
                this.props.notifySuccess(resp.message);
            }.bind(this),
            error: function (error) {
                this.props.notifyError(error.responseJSON.message);
            }.bind(this)
        })
    }

    selectScheduleType = (e) => {
        this.setState({ selectedScheduleType: e.target.value });
    }

    selectedDays = (selectedDays) => {
        this.setState({
            selectedDays: selectedDays
        })
    }

    selectMultipleDates = (selectedDates) => {
        this.setState({
            selectedDates: selectedDates
        })
    }

    changeTitle = (e) => {
        this.setState({ title: e.target.value });
    }

    changeDescription = (e) => {
        this.setState({ description: e.target.value });
    }
    onChangeStartTime = (e) => {
        this.setState({
            startTime: e.target.value
        });
    }
    onChangeEndTime = (e) => {
        this.setState({
            endTime: e.target.value
        });
    }

    toggelButton = () => {
        // this.setState({
        //     viewCustomModal: !this.state.viewCustomModal
        // })
    }

    toggle = () => {
        // this.setState({
        //     tooltipOpen: !this.state.tooltipOpen
        // });
    }

    toggleModal = () => {
        // this.setState({
        //     viewSchedule: !this.state.viewSchedule
        // });
    }

    scheduleOptions = () => {
        return this.state.scheduleOptions.map((option, i) => {
            return (<option key={i} value={option}>{option}</option>)
        })
    }


    scheduleViewModal = (schedule) => {
        this.setState({
            scheduleEditModal: !this.state.scheduleEditModal,
            title: schedule.title,
            description: schedule.description,
            selectedScheduleType: schedule.scheduleType,
            selectedDates: schedule.selectedDates,
            selectedDays: schedule.selectedDays,
            startTime: schedule.startTime,
            endTime: schedule.endTime,
            scheduleId: schedule._id
        })
    }

    updateSchedule = (event) => {
        event.preventDefault();
        let data = {
            title: this.state.title,
            description: this.state.description,
            scheduleType: this.state.selectedScheduleType,
            selectedDates: this.state.selectedDates.length ? this.convertSelectedDaysIntoArray(this.state.selectedDates) : [],
            selectedDays: this.state.selectedDays.length ? this.convertSelectedDaysIntoArray(this.state.selectedDays) : [],
            startTime: this.state.startTime,
            endTime: this.state.endTime,
            _id: this.state.scheduleId
        }
        $.ajax({
            url: '/api/v1/schedule',
            method: 'PUT',
            data: JSON.stringify(data),
            success: function (resp) {
                this.setState({
                    scheduleEditModal: !this.state.scheduleEditModal
                });
                this.fetchStreamList();
                this.props.notifySuccess(resp.message);
            }.bind(this),
            error: function (error) {
                this.props.notifyError(error.responseJSON.message);
            }.bind(this)
        })
    }

    convertSelectedDaysIntoArray = (selectedDays) => {
        if (selectedDays && selectedDays.length) {
            return selectedDays.map((days) => {
                if (days.value)
                    return days.value;
                return days;
            })
        }
    }

    toggleConfirmModal = (schedule) => {
        this.setState({
            confirmModal: !this.state.confirmModal,
            scheduleId: schedule._id
        });
    }


    selectChange = (selectedOption) => {
        this.setState({ selectedOption });

    }

    render() {


        const { t } = this.props;
        const { match } = this.props;

        const selectedOptionsStyles = {
            color: "#3c763d",
            backgroundColor: "#dff0d8"
        };
        const optionsListStyles = {
            backgroundColor: "#dff0d8",
            color: "#3c763d"
        };

        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        })

        const columns = [{
            Header: 'Nome',
            accessor: 'name' // String-based value accessors!
        },
        {
            Header: 'Título',
            accessor: 'title',

        },
        {
            Header: 'Tipo',
            accessor: 'type'
        },
        {
            Header: 'Tipo de programação',
            accessor: 'scheduleType'
        },
        {
            Header: 'Hora de início',
            accessor: 'startTime',
        },
        {
            Header: 'Fim do tempo',
            accessor: 'endTime',
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: props => <div>{props.value ? 'Ativa' : 'Inativa'}</div>

        }, {
            Header: 'Açao',
            accessor: 'action',

            Cell: props => {
                const schedule = props.original;
                return (
                    <div>
                        <button
                            title="Edit"
                            className="button-reset px-3"
                            onClick={() => this.scheduleViewModal(schedule)}>
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                            title="Delete"
                            className="button-reset px-3"
                            onClick={() => this.toggleConfirmModal(schedule)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                    </div>)
            }
        }]

        return (
            <div className="Stats flex-grow">
                <div className="col-md-12 relay-icons">
                    <button className="btn add-button scheduleButton" onClick={() => { this.props.history.push("/main") }}>
                        <i className="fa fa-plus" aria-hidden="true"></i> Adicionar agendamento</button>
                </div>

                <div className="Stats__table p-4 ">
                    <ReactTable className="-highlight -striped text-center"
                        resizable={false}
                        data={this.state.scheduleList}
                        columns={columns}
                        defaultPageSize={10}
                        pages={this.state.totalPages}
                        page={this.state.page} />                    
                </div>
                <ConfirmDialog
                    t={this.props.t}
                    type='delete'
                    isOpen={this.state.confirmModal}
                    toggle={this.toggleConfirmModal}
                    confirm={this.deletSchedule} />

                <Modal className="scheduleModal" isOpen={this.state.scheduleEditModal} toggle={this.scheduleViewModal} >
                    <ModalBody>
                        <Form className="DataFields titleModal" onSubmit={this.updateSchedule}>
                            <span onClick={this.scheduleViewModal} className="titleCloseModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
                            <div className="form-group">
                                <label className="mr-sm-2">
                                    Título</label>
                                <Input type="text" name="title" defaultValue={this.state.title} onChange={this.changeTitle} className="form-control" />
                            </div>
                            <div className="form-group">
                                <label className="mr-sm-2">
                                    Descrição</label>
                                <Textarea
                                    rows="3"
                                    id="description"
                                    name="description"
                                    value={this.state.description}
                                    onChange={this.changeDescription}
                                    className="form-control input-field-textarea"
                                    maxLength={100} />
                            </div>
                            <div className="form-group">
                                <label className="mr-sm-2">
                                    Repita a programação</label>
                                <Select
                                    type="select"
                                    name="schedule"
                                    id="schedule"
                                    className="form-control"
                                    value={this.state.selectedScheduleType}
                                    onChange={this.selectScheduleType} >
                                    {this.scheduleOptions()}
                                </Select>
                            </div>
                            {(this.state.selectedScheduleType == this.state.scheduleOptions[2]) ?
                                <div className="form-group">
                                    <MultiSelect
                                        options={this.state.weekly}
                                        onChange={this.selectedDays}
                                        value={this.state.selectedDays}
                                        placeholder="Selecionar vários dias"
                                        joinValues
                                        multi
                                    />
                                </div> : this.state.selectedScheduleType == this.state.scheduleOptions[3] ?
                                    <div className="form-group">
                                        <label className="mr-sm-2">
                                            selecione várias datas</label>
                                        <MultiSelect
                                            options={this.state.dates}
                                            onChange={this.selectMultipleDates}
                                            value={this.state.selectedDates}
                                            placeholder="selecione várias datas"
                                            joinValues
                                            multi
                                        />
                                    </div>
                                    : null}
                            <div className="form-group">
                                <Row>
                                    <Col>
                                        <label className="mr-sm-2">
                                            Hora de início</label>
                                    </Col>
                                    <Col>
                                        <Input
                                            id="time"
                                            label="startTime"
                                            type="time"
                                            defaultValue={this.state.startTime}
                                            className="timeWidth"
                                            onChange={this.onChangeStartTime}
                                        />
                                    </Col>
                                </Row>
                            </div>
                            <div className="form-group">
                                <Row>
                                    <Col>
                                        <label className="mr-sm-2">
                                            Fim do tempo</label>
                                    </Col>
                                    <Col>
                                        <Input
                                            id="time"
                                            label="startTime"
                                            type="time"
                                            defaultValue={this.state.endTime}
                                            className="timeWidth"
                                            onChange={this.onChangeEndTime}
                                        />
                                    </Col>
                                </Row>
                            </div>
                            <FormGroup className="text-center">
                                <Button type="submit" className="btn btn--submit mx-auto">Agenda de atualização</Button>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}



export default translate('translations')(ScheduleList);


// WEBPACK FOOTER //
// ./src/components/DashboardPage/Dashboard/Video/ScheduleList/ScheduleList.js